<template>
  <!-- <div class="coin-balance" @click="$router.push('/recharge')"> -->
  <div class="coin-balance" >
    <div class="coin-icon">F</div>
    <span class="coin-amount">{{ userCoins.toLocaleString() }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CoinBalance',
  computed: {
    ...mapGetters(['userCoins'])
  }
}
</script>

<style scoped>
.coin-balance {
  background: var(--bg-glass);
  backdrop-filter: blur(var(--blur-md));
  -webkit-backdrop-filter: blur(var(--blur-md));
  border: 1px solid var(--border-light);
  border-radius: 980px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: var(--shadow-sm);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.coin-balance:hover {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: var(--shadow-md);
  transform: scale(1.02);
}

.coin-icon {
  width: 28px;
  height: 28px;
  background: var(--coin-gold);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: white;
  box-shadow: 0 4px 12px rgba(243, 156, 18, 0.3);
}

.coin-amount {
  font-size: 17px;
  font-weight: 600;
  color: var(--text-dark);
  letter-spacing: -0.01em;
}

@media (max-width: 768px) {
  .coin-balance {
    padding: 8px 16px;
  }

  .coin-icon {
    width: 24px;
    height: 24px;
    font-size: 14px;
  }
}
</style>